import { Button } from "antd";
import { ModalPortal } from "../../../../../common/components/modalPortal/modalPortal";
import { EditInvoiceModal } from "./editInvoiceModal";
import { useEditInvoice } from "./useEditInvoice";

export const EditInvoiceButton = ({ invoiceDetails, onSuccess }) => {
  const { loading, error, errorStatements, onFinish, handleClose } =
    useEditInvoice(invoiceDetails, onSuccess);

  return (
    <ModalPortal
      renderTrigger={(props) => (
        <Button type="primary" {...props}>
          Edit
        </Button>
      )}
    >
      {(props) => (
        <EditInvoiceModal
          invoiceDetails={invoiceDetails}
          loading={loading}
          error={error}
          errorStatements={errorStatements}
          onFinish={onFinish(props.closeModal)}
          {...props}
          closeModal={handleClose(props.closeModal)}
        />
      )}
    </ModalPortal>
  );
};